export const ApplicationLink = {
    "请选择应用环节":"Please select an section",
    "添加应用环节":"Add Link",
    "请输入应用环节":"Please enter the application section",
    "确定要删除应用环节":"Confirm to delete the application phase",
    "删除后将不可恢复":"the deletion will not be recoverable",
}